import { onUnmounted } from 'intact-vue-next';
import { useState } from './useState';
export function useDraggable(options) {
  var dragging = useState(false);
  function start(e) {
    // ignore if it isn't left key
    if (e.which !== 1 || options.disable != null && options.disable()) return;
    dragging.set(true);
    if (options.onStart) {
      options.onStart(e);
    }
    document.addEventListener('mousemove', move);
    document.addEventListener('mouseup', end);
  }
  function move(e) {
    if (options.disable != null && options.disable()) return;
    e.preventDefault();
    if (dragging.value) {
      options.onMove(e);
    }
  }
  function end(e) {
    if (dragging.value) {
      dragging.set(false);
      if (options.onEnd) {
        options.onEnd(e);
      }
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseup', end);
    }
  }
  onUnmounted(function () {
    return end();
  });
  return {
    start: start,
    dragging: dragging
  };
}